import React, { Component } from 'react';
import { allMember } from '../../Redux/action/memberAction';
import { memberAditionData } from '../../Redux/action/memberAction';
import { onCityLocation } from '../../Redux/action/memberAction';
import {
  onBuildingLocation1,
  exportFileFunc,
  onBuildingLocation,
} from '../../Redux/action/memberAction';
import { connect } from 'react-redux';
import axios from 'axios';
import $ from 'jquery';

import { dataUser, dataLocation } from '../Helpers/util';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwInput from '../Common/FormComponent/SwInput';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';
import SwIconButton from '../Common/SwIconButton/SwIconButton';
import SwTooltip from '../Common/SwTooltip/SwTooltip';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);

var FormData = require('form-data');

class MainHeadingFilterMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      showAddMemberFilter: false,
      refreshCity: null,
      refreshBuilding: null,
      refreshFloor: null,
      pgno: this.props.filterPg,
      row: this.props.filterRow,
      empname: '',
      email: '',
      phone: '',
      filterstatus: '',
      city: '',
      userid: UserObj ? UserObj.rec_id : null,
      floor: '',
      building: '',
      role: '',
      vaccinated: null,
      checked: false,
      required: {
        cityName: true,
        buildingName: false,
      },
    };
  }
  changeSelect = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  resetFilters = () => {
    this.setState(
      {
        empname: '',
        email: '',
        phone: '',
        status: '',
        city: '',
        floor: '',
        building: '',
        refreshCity: null,
        refreshBuilding: null,
        refreshFloor: null,
        vaccinated: null,
        filterstatus: '',
      },
   
    );
  };

  submitFilter = e => {
    e.preventDefault();
    if (this.state.city != null && this.state.building == null) {
      this.setState({ required: { buildingName: true } });
    } else {
      this.setState({ required: { buildingName: false } });
    }
    const formData = new FormData();
    formData.append('empname', this.state.empname);
    formData.append('email', this.state.email);
    formData.append('phone', this.state.phone);
    formData.append('status', this.state.filterstatus);
    formData.append('city', this.state.city);
    formData.append('floor', this.state.floor);
    formData.append('building', this.state.building);
    formData.append('refreshCity', this.state.refreshCity);
    formData.append('refreshBuilding', this.state.refreshBuilding);
    formData.append('refreshFloor', this.state.refreshFloor);
    formData.append('pgno', this.props.filterPg);
    formData.append('row', this.props.filterRow);
    formData.append('company_id', this.state.company_id);
    let authToken = JSON.parse(localStorage.getItem('headData'));
    // formData.append('auth', 'U21hcnR3b3Jrcy1GZWVkYmFjay1BUEktVjEtMjAxOQ==');
    const param2 = {
      empname: this.state.empname,
      email: this.state.email,
      phone: this.state.phone,
      status: this.state.filterstatus,
      city: this.state.city,
      floor: this.state.floor,
      building: this.state.building,
      refreshCity: this.state.refreshCity,
      refreshBuilding: this.state.refreshBuilding,
      refreshFloor: this.state.refreshFloor,
      pgno: this.props.filterPg,
      row: this.props.filterRow,
      company_id: this.state.company_id,
      vaccinated: this.state.vaccinated,
      user_role_id: this.state.role,
      userid: this.state.userid,
      location: LocationObj,
    };

    const params = this.state;
    this.props.allMember(param2);
    this.props.onSelectLanguage(param2);
    this.props.exportFileFunc(formData);
    this.props.getAllExportData(param2);
    this.setState({ showAddMemberFilter: false });
  };

  handelChangeVal = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleChange4 = city => {
    var required = this.state.required;
    required.buildingName = true;
    this.setState({
      city: city?.value,
      refreshCity: city,
      required: required,
    });
    this.setState({ refreshFloor: { value: '', label: 'Please select' } });
    let parm = {
      spoc: this.state.userid,
      client: this.state.company_id,
      city: city?.value,
    };

    // this.setState({ city: city.value, refreshCity: city });
    // this.props.onCityLocation1(parm);
    this.props.onBuildingLocation1(parm);
    this.state.refreshBuilding = null;
  };

  handleChange5 = buildingid => {
    var required = this.state.required;
    required.buildingName = false;
    this.setState({
      buildingid: buildingid.value,
      refreshBuilding: buildingid,
      required: required,
    });
    let parm = {
      buildingid: buildingid.value,
    };
    this.setState({ building: buildingid.value, refreshBuilding: buildingid });
    // this.setState({ floor: buildingid.value, refreshFloor: buildingid });
    this.setState({ refreshFloor: { value: '', label: 'Please select' } });
    this.props.onBuildingLocation(parm);
  };

  handleChange = (val, name) => {
    this.setState({ floor: val.value, refreshFloor: val });
  };

  onChangeValue = event => {
    this.setState({
      checked: !this.state.checked,
      [event.target.name]: event.target.value,
    });
  };

  componentDidMount() {
    let authToken = JSON.parse(localStorage.getItem('headData'));
    this.props.memberAditionData();
    axios
      .get(
        `${process.env.REACT_APP_API_URL}userRoles/getRoleList/${
          this.state.company_id
        }`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        if (response.data && response.data.status == 'success') {
          this.setState({
            orgRole: response.data.data.result,
          });
        }
      })
      .catch(err => {
        console.log('Error: ' + err);
      });
  }

  changeRole = role => {
    this.setState({
      role: role,
    });
  };

  componentWillReceiveProps() {
    this.setState({
      pgno: this.props.filterPg,
      row: this.props.filterRow,
    });
  }

  // componentDidMount() {
  //   this.props.memberAditionData();
  // }

  StatusMethod = status => {
    this.setState({ filterstatus: status.value });
  };

  render() {
    const ticketStatus = [
      {
        value: 'active',
        label: 'Has Access',
      },
      {
        value: 'inactive',
        label: 'No Access',
      },
    ];
    const { popUp } = this.props;
    const newMember = this.props.newMemberData.NewMemberData;
    const activeUserList = this.props.activeUserList.userList;
    const NewCity = this.props.CityData1.CityData1;

    const Floordata = this.props.BuildingData?.BuildingData;
    const BuildingData = this.props.CityData1.BuildingData1;

    //--name---///
    const options = [];
    if (newMember.list !== 0) {
      newMember.list &&
        newMember.list.map((items, i) => {
          options.push({
            value: items.fname,
            label: items.fname + ' ' + items.lname,
          });
        });
    }
    //--name---///
    //--email--///
    const options2 = [];
    if (newMember.list !== 0) {
      newMember.list &&
        newMember.list.map((items, i) => {
          options2.push({ value: items.email, label: items.email });
        });
    }
    //--email---///
    //--Phone--///
    const options3 = [];
    if (newMember.list !== 0) {
      newMember.list &&
        newMember.list.map((items, i) => {
          options3.push({ value: items.phone, label: items.phone });
        });
    }
    //--phone---///
    //--City--///
    const options4 = [];

    if (NewCity !== 0) {
      NewCity &&
        NewCity.map((items, i) => {
          options4.push({ value: items.city_id, label: items.city_name });
        });
    }
    //--City---///
    //--building--///
    const options5 = [];
    if (BuildingData !== 0) {
      BuildingData &&
        BuildingData.map((items, i) => {
          options5.push({
            value: items.rec_id,
            label: items.location_name,
          });
        });
    }
    //--building---///
    //--floor--///
    const options6 = [];
    if (Floordata !== 0) {
      Floordata &&
        Floordata.map((items, i) => {
          options6.push({
            value: items.rec_id,
            label: items.business_name,
          });
        });
    }

    const options7 = [];
    if (this.state.orgRole !== 0) {
      this.state.orgRole &&
        this.state.orgRole.map((items, i) => {
          options7.push({ value: items.id, label: items.role_name });
        });
    }

    //--floor---///

    return (
      <>
        <SwOffCanvas
          show={this.state.showAddMemberFilter}
          onClose={() => {
            this.resetFilters();
            this.setState({ showAddMemberFilter: false });
          }}
          title="Filters"
          placement="end"
          backdrop="static"
          keyboard={false}
          footer={
            <div className="OffCanvasFooter_Btns">
              <SwButton
                variant="dark-outline"
                onClick={() => {
                  this?.resetFilters();
                }}
              >
                Reset
              </SwButton>

              <SwButton
                variant="primary"
                className="ml10"
                disabled={this?.state?.required?.buildingName}
                onClick={this.submitFilter}
              >
                Apply
              </SwButton>
            </div>
          }
        >
          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Name</label>
                <SwInput
                  type="text"
                  name="empname"
                  value={this.state.empname}
                  onChange={this.handelChangeVal}
                  placeholder="Enter Name"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Corporate Email</label>
                <SwInput
                  type="text"
                  name="email"
                  value={this.state.email}
                  onChange={this.handelChangeVal}
                  placeholder="Enter Email"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Phone</label>
                <SwInput
                  type="number"
                  name="phone"
                  value={this.state.phone}
                  onChange={this.handelChangeVal}
                  placeholder="Enter Phone"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Status</label>
                <SwSelect
                  name="filterstatus"
                  options={ticketStatus} // [{ value, label }, ...]
                  value={
                    ticketStatus.find(
                      opt => opt.value === this.state.filterstatus,
                    ) || null
                  }
                  onChange={this.StatusMethod}
                  placeholder="Select Status"
                  isClearable={false}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">
                  City Name
                  <SwTooltip
                    placement="right"
                    content={<>Please select City Name first</>}
                  >
                    <span role="button" className="ms-2">
                      <i class="bi bi-info-circle" />
                    </span>
                  </SwTooltip>
                </label>

                <SwSelect
                  value={
                    options4.find(
                      opt => opt.value === this.state.refreshCity?.value,
                    ) ||
                    this.state.refreshCity ||
                    null
                  }
                  onChange={this.handleChange4}
                  options={options4}
                  placeholder="Select City"
                  isClearable={false}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">
                  Building Name
                  <SwTooltip
                    placement="right"
                    content={<>Please select Building Name</>}
                  >
                    <span role="button" className="ms-2">
                      <i class="bi bi-info-circle" />
                    </span>
                  </SwTooltip>
                </label>

                <SwSelect
                  value={
                    options5.find(
                      opt => opt.value === this.state.refreshBuilding?.value,
                    ) ||
                    this.state.refreshBuilding ||
                    null
                  }
                  onChange={this.handleChange5}
                  options={options5}
                  placeholder="Select Building"
                  isClearable={false}
                />

                {this.state.required.buildingName && (
                  <span className="SwTextDanger SwTextSmall">
                    Please select building name
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Floor</label>

                <SwSelect
                  value={
                    options6.find(
                      opt => opt.value === this.state.refreshFloor?.value,
                    ) ||
                    this.state.refreshFloor ||
                    null
                  }
                  onChange={floor => this.handleChange(floor, 'building')}
                  options={options6}
                  placeholder="Select Floor"
                  isClearable={false}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-xl-12 col-lg-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Vaccinated</label>

                <SwRadio
                  name="vaccinated"
                  id="VaccinatedBothDose"
                  label="Vaccinated (Both Dose)"
                  value="2"
                  checked={this.state.vaccinated === '2'}
                  onChange={this.onChangeValue}
                />

                <SwRadio
                  name="vaccinated"
                  id="VaccinatedFirstDose"
                  label="First Dose Completed"
                  value="1"
                  checked={this.state.vaccinated === '1'}
                  onChange={this.onChangeValue}
                />

                <SwRadio
                  name="vaccinated"
                  id="Not Vaccinated"
                  label="Not Vaccinated"
                  value="0"
                  checked={this.state.vaccinated === '0'}
                  onChange={this.onChangeValue}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 col-md-6 col-xs-12 col-sm-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">
                  Role<span className="Required">*</span>
                </label>

                <SwSelect
                  value={
                    options7.find(opt => opt.value === this.state.role) || null
                  }
                  onChange={selectedOption =>
                    this.changeRole(selectedOption?.value)
                  }
                  options={options7}
                  placeholder="Select Role"
                  isClearable={false}
                />
                <span className="SwTextDanger SwTextSmall">
                  {' '}
                  {this.state.roleError}
                </span>
              </div>
            </div>

            <br />
          </div>
        </SwOffCanvas>

        <SwIconButton
          size="sm"
          onClick={() => this.setState({ showAddMemberFilter: true })}
        >
          <i className="bi bi-funnel" />
        </SwIconButton>
      </>
    );
  }
}
const mapStateToProps = state => ({
  activeUserList: state.activeUserList,
  newMemberData: state.activeUserList,
  CityData: state.activeUserList,
  CityData1: state.activeUserList,
  BuildingData: state.activeUserList,
});
const mapActionsToProps = {
  allMember,
  memberAditionData,
  onCityLocation,

  onBuildingLocation1,
  exportFileFunc,
  onBuildingLocation,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(MainHeadingFilterMember);
